import React from "react";
import PopUpOther from "./PopUpCreditCode";
import SelectFix from "./_SelectFix";
import { genURL } from "../_getjson";
import axios from "axios";
import SelectDatas from "../PopUp/SelectData";
import FullScreenDialog from "../PopUp/FullScreendialogs/FullScreen";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import Radiohotizental from "../Components/Radiobutton/radiohotizental";
import InputTemplate from "../Components/CustomInput/InputTemplate/inputtemplate";
import { Grid } from "@mui/material";
export default class data extends React.Component {
  constructor(props) {
    super(props);
    this.TAXID = React.createRef();
    this.Ar_remark1 = React.createRef();
    this.state = {
      data3: "",
      Taxid: "",
      Persontype: this.props.p3_1,
      Creditflag: this.props.p3_2,
      Creditcode: this.props.p3_3,
      Creditshare: this.props.p3_4,
      CCreditflag: "",
      CCreditcode: "",
    };
  }
  onKey = (type) => {
    var data3 = "";
    switch (type) {
      case "Taxid":
        data3 = "Taxid|" + this.TAXID.current.value;
        break;
      case "Arremark1":
        data3 = "Arremark1|" + this.Ar_remark1.current.value;
        break;
      default:
        break;
    }
    setTimeout(() => {
      this.props.Getdata("data3", data3);
    }, 50);
  };
  componentDidMount() {
    //---------รหัสเครดิต :
    console.log(this.props.p3_5);
    if (this.props.p3_5) {
      var url1 = "CSGLCHART/ByCode?code=" + this.props.p3_5;
      console.log(genURL(url1));
      axios
        .get(genURL(url1))
        .then((res) => {
          if (res.data.length === 1) {
            this.setState({ Accountcode: res.data[0].CODE });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    //---------เลขประจำตัวผู้เสียภาษี :
    var props5 = this.props.p3_6;
    if (props5) {
      this.TAXID.current.value = props5;
    }
    //------- หมายเหตุ1 :
    var props6 = this.props.p3_7;
    if (props6) {
      this.Ar_remark1.current.value = props6;
    }
  }
  SelectSetData = async (type, data) => {
    var pdata = data.split("|");
    var data2 = pdata[1];
    var data3 = "";
    if (data) {
      switch (type) {
        case "Persontype":
          data3 = (await type) + "|" + data;
          break;
        case "Creditflag":
          data3 = (await type) + "|" + data;
          break;
        case "Creditcode":
          data3 = (await type) + "|" + data;
          break;
        case "Creditshare":
          data3 = (await type) + "|" + data;
          break;
        case "Accountcode":
          data3 = (await type) + "|" + data;
          this.setState({ Accountcode: data2 });
          this.setState({ CAccountcode: pdata[0] });
          break;
        case "Calendar1":
          data3 = (await type) + "|" + data;
          this.setState({ Openedate: data });
          break;
        default:
          break;
      }
    }
    this.props.Getdata("data3", data3);
  };
  SetPopup = (data) => {
    this.setState({ PopUpTYpe: data });
    //ชื่อ
    this.setState({ typeFullScreenDialog: data });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหารหัสบัญชี-glchart" });
  };
  Get_PopUpOther = (data, datatxt) => {
    this.CloseDialog(false);
    var data3 = "";
    switch (this.state.PopUpTYpe) {
      case "Accountcode":
        data3 = "Accountcode|" + data;
        this.setState({ Accountcode: data });
        break;
      default:
        break;
    }
    setTimeout(() => {
      this.props.Getdata("data3", data3);
    }, 50);
  };
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
  };

  typeTaxnumbervalueChange = (e) => {
    //console.log("typeTaxnumberdefaultvalue", e);
    this.setState({ typeTaxnumberdefaultvalue: e });
    this.props.typeTaxnumber(e);
  };
  render() {
    const type = this.state.typeFullScreenDialog;
    return (
      <Grid container spacing={2}>
        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.CloseDialog(e)}
        >
          {type === "Accountcode" ? (
            <PopUpOther
              Get_PopUpOther={this.Get_PopUpOther}
              type={this.state.PopUpTYpe}
              Data={this.state.valuePopup}
            />
          ) : null}
        </FullScreenDialog>

        <Grid item xs={8}>
          <SelectDatas
            origin="Persontype" // ประเภทบุคคล
            valueSelect={(e) => this.SelectSetData("Persontype", e)} // รับค่ากลับ
            title="ประเภทบุคคล"
            defaultselect={this.state.Persontype} // ค่าเริ่มต้นของ ประเภทบุคคล
          />
        </Grid>
        <Grid item xs={8}>
          <SelectDatas
            origin="Creditflag" // สถานะเครดิต
            valueSelect={(e) => this.SelectSetData("Creditflag", e)} // รับค่ากลับ
            title="สถานะเครดิต"
            defaultselect={this.state.Creditflag} // ค่าเริ่มต้นของ สถานะเครดิต
          />
        </Grid>
        <Grid item xs={8}>
          <SelectDatas
            origin="Creditcode" // รหัสเครดิต
            valueSelect={(e) => this.SelectSetData("Creditcode", e)} // รับค่ากลับ
            title="รหัสเครดิต"
            defaultselect={this.state.Creditcode} // ค่าเริ่มต้นของ รหัสเครดิต
          />
        </Grid>
        <Grid item xs={8}>
          <SelectDatas
            origin="Creditshare" // ประเภทวงเงิน
            valueSelect={(e) => this.SelectSetData("Creditshare", e)} // รับค่ากลับ
            title="ประเภทวงเงิน"
            defaultselect={this.state.Creditshare} // ค่าเริ่มต้นของ ประเภทวงเงิน
          />
        </Grid>
        <Grid item xs={8}>
          <InputTemplate
            title={"รหัสบัญชีลูกค้ารายตัว"}
            children={
              <>
                <input
                  id="5"
                  type="text"
                  className="form-control"
                  name="Accountcode"
                  value={this.state.Accountcode}
                  style={{ marginTop: "-5px", height: "33px" }}
                />
                <span
                  className="input-group-addon icon"
                  onClick={this.SetPopup.bind(null, "Accountcode")}
                  style={{ marginTop: "-5px", height: "35px" }}
                >
                  {" "}
                  <i className="fas fa-search"></i>{" "}
                </span>
              </>
            }
          />
        </Grid>

        <Grid item xs={8}>
          <InputTemplate
            title={"เลขประจำตัวผู้เสียภาษี"}
            children={
              <input
                id="6"
                type="text"
                className="form-control"
                ref={this.TAXID}
                onBlur={() => this.onKey("Taxid")}
                style={{ marginTop: "-5px", height: "33px" }}
              />
            }
          />
        </Grid>
        <Grid item xs={8}>
          <Radiohotizental
            label={""}
            data={[
              { id: "0", name: "ไม่ตรงกับรหัสลูกค้า" },
              { id: "1", name: "ตรงกับรหัสลูกค้า" },
            ]}
            defaultvalue={
              this.state.typeTaxnumberdefaultvalue
                ? this.state.typeTaxnumberdefaultvalue
                : "1"
            }
            valueChange={(e) => {
              this.typeTaxnumbervalueChange(e);
            }}
          />
        </Grid>
        <Grid item xs={8}>
          <InputTemplate
            title={"หมายเหตุ1"}
            lineHeight={6.5}
            children={
              <textarea
                style={{ resize: "none", marginTop: "-5px" }}
                rows="4"
                type="text"
                className="form-control"
                ref={this.Ar_remark1}
                onBlur={() => this.onKey("Arremark1")}
              />
            }
          />
        </Grid>
      </Grid>
    );
  }
}
